import { createRoot } from 'react-dom/client'
import { css } from '@firebolt-dev/css'
import { useState } from 'react'

function App() {
  const [src, setSrc] = useState(null)
  return (
    <div
      css={css`
        width: 100dvw;
        height: 100dvh;
        position: relative;
        iframe {
          width: 100%;
          height: 100%;
          border: 0;
        }
        .test {
          position: absolute;
          background: black;
          right: 0;
          bottom: 0;
          padding: 10px;
          color: 'white';
        }
      `}
    >
      {src && (
        <iframe
          src={src}
          sandbox='allow-scripts allow-same-origin allow-pointer-lock allow-storage-access-by-user-activation allow-downloads'
          allow='xr-spatial-tracking; clipboard-read; clipboard-write; autoplay; fullscreen; microphone'
        />
      )}
      <div className='test'>
        <div onClick={() => setSrc('https://chill.hyperfy.xyz')}>Chill</div>
        <div onClick={() => setSrc('https://vox.b34k3r.com/')}>Vox 1</div>
        <div onClick={() => setSrc('https://vox.hyperworld.host/')}>Vox 2</div>
        <div onClick={() => setSrc('https://roustan.xyz')}>Roustan</div>
      </div>
    </div>
  )
}

const root = createRoot(document.getElementById('root'))
root.render(<App />)
